import camelCase from 'lodash-es/camelCase';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
var convertToAppTheme = function (theme) {
    if (!theme) {
        return;
    }
    var appTheme = {};
    for (var _i = 0, _a = Object.keys(theme); _i < _a.length; _i++) {
        var key = _a[_i];
        if (key.includes('-contrast')) {
            continue;
        }
        appTheme[camelCase(key)] = typeof theme[key] === 'object' ?
            convertToAppTheme(theme[key])
            : theme[key];
    }
    return appTheme;
};
var ɵ0 = convertToAppTheme;
var THEME_MAP = {};
var ColorService = /** @class */ (function () {
    function ColorService(_document) {
        this._document = _document;
    }
    ColorService.prototype.getColor = function (color) {
        return this.theme.colors[color];
    };
    Object.defineProperty(ColorService.prototype, "theme", {
        get: function () {
            var themeKey = this._document.body.dataset['theme'];
            if (THEME_MAP[themeKey]) {
                return THEME_MAP[themeKey];
            }
            this._window = this._document.defaultView;
            var colorJson = this._window.getComputedStyle(this._document.body, '::before').content;
            var colors = JSON.parse(this._normalizeJson(colorJson));
            return THEME_MAP[themeKey] = convertToAppTheme(colors);
        },
        enumerable: true,
        configurable: true
    });
    // Reference: https://css-tricks.com/making-sass-talk-to-javascript-with-json/
    ColorService.prototype._normalizeJson = function (json) {
        // normalize browser inconsistencies
        if (typeof json === 'string' || json instanceof String) {
            json = json.replace(/^['"]+|\s+|\\|(;\s?})+|['"]$/g, '');
        }
        return json;
    };
    ColorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ColorService_Factory() { return new ColorService(i0.ɵɵinject(i1.DOCUMENT)); }, token: ColorService, providedIn: "root" });
    return ColorService;
}());
export { ColorService };
export { ɵ0 };
